import api3RD from "constants/api3RD";
import { Game3rdTransferModel } from "models/fundTransferModel";

export const list3RDGame: Game3rdTransferModel[] = [

	// === Sport ===
	{
		balance: 0,
		money: 1000,
		balancename: "IBC2 Sport",
		providercode: "IBC2",
		msg: "",
		message: "",
		gameType: "SB",
		isLoaded: false,
        action: api3RD.ibc2Sport,
        actiond: api3RD.ibc2Transfer,
        actionw: api3RD.ibc2Transfer,
		port: api3RD.ibc2Login,
		valSname: 'Sportsbook',
		valSvalue: "ibc2_sport",
	},
	{
		balance: 0,
		money: 1000,
		balancename: "CMD368 Sport",
		providercode: "CMD368",
		msg: "",
		message: "",
		gameType: "SB",
		isLoaded: false,
        action: api3RD.cmdSport,
        actiond: api3RD.cmdSportDeposit,
        actionw: api3RD.cmdSportWithdraw,
		port: api3RD.cmdSportLogin,
		valSname: 'Sportsbook',
		valSvalue: "cmd_sport",
	},
	{
		balance: 0,
		money: 1,
		balancename: "BTI SPORTS",
		providercode: "BTI",
		msg: "",
		message: "",
		gameType: "SB",
		isLoaded: false,
        action: api3RD.btiSport,
        actiond: api3RD.btiSportDeposit,
        actionw: api3RD.btiSportWithdraw,
		port: api3RD.btiSportLogin,
		valSname: 'Sportsbook',
		valSvalue: "bti_sport",
	},

	// === Live Casino ===
	// === AG (Play ACE Gaming) đã tạm ẩn - không hiển thị & không gọi API AG ===
	// {
	// 	balance: 0,
	// 	money: 1,
	// 	balancename: "Play ACE Gaming",
	// 	providercode: "AG",
	// 	msg: "",
	// 	message: "",
	// 	gameType: "LC",
	// 	isLoaded: false,
	//     action: api3RD.agBalance,
	//     actiond: api3RD.agDeposit,
	//     actionw: api3RD.agWithdraw,
	// 	port: api3RD.agLogin,
	// 	valSname: 'LiveCasino',
	// 	valSvalue: "ag_casino",
	// },
	{
		balance: 0,
		money: 1,
		balancename: 'PRAGMATIC CASINO',
		providercode: "PRAG",
		msg: "",
		message: "",
		gameType: "LC",
		isLoaded: false,
        action: api3RD.pragmaticBalance,
        actiond: api3RD.pragmaticTransfer,
        actionw: api3RD.pragmaticTransfer,
		port: api3RD.pragmaticLogin,
		valSname: 'LiveCasino',
        valSvalue: "pragmatic_casino",
	},
	{
		balance: 0,
		money: 1,
		balancename: "Evolution Gaming",
		providercode: "EVOLUTION",
		msg: "",
		message: "",
		gameType: "LC",
		isLoaded: false,
        action: api3RD.evolutionBalance,
        actiond: api3RD.evolutionTransfer,
        actionw: api3RD.evolutionTransfer,
		port: api3RD.evolutionLogin,
		valSname: 'LiveCasino',
        valSvalue: "evolution_casino",
	},
	{
		balance: 0,
		money: 1,
		balancename: "DG Gaming",
		providercode: "DG",
		msg: "",
		message: "",
		gameType: "LC",
		isLoaded: false,
        action: api3RD.dgBalance,
        actiond: api3RD.dgTransfer,
        actionw: api3RD.dgTransfer,
		port: api3RD.dgLogin,
		valSname: 'LiveCasino',
		valSvalue: "dg_casino",
	},
	{
		balance: 0,
		money: 1,
		balancename: "Sexy Gaming",
		providercode: "SG",
		msg: "",
		message: "",
		gameType: "LC",
		isLoaded: false,
        action: api3RD.sgBalance,
        actiond: api3RD.sgDeposit,
        actionw: api3RD.sgWithdraw,
		port: api3RD.sgLogin,
		valSname: 'LiveCasino',
        valSvalue: "sg_casino",
	},
	{
		balance: 0,
		money: 1000,
		balancename: "Live Casino SA",
		providercode: "SA",
		msg: "",
		message: "",
		gameType: "LC",
		isLoaded: false,
        action: api3RD.saBalance,
        actiond: api3RD.saDeposit,
        actionw: api3RD.saWithdraw,
		port: api3RD.saLogin,
		valSname: 'LiveCasino',
		valSvalue: "sa_casino",
	},
	{
		balance: 0,
		money: 1000,
		balancename: "WM Casino",
		providercode: "WM",
		msg: "",
		message: "",
		gameType: "LC",
		isLoaded: false,
        action: api3RD.wmBalance,
        actiond: api3RD.wmTransfer,
        actionw: api3RD.wmTransfer,
		port: api3RD.wmLogin,
		valSname: 'LiveCasino',
    	valSvalue: "wm_casino",
	},

	// === Slots Game ===
	{
		balance: 0,
		money: 1000,
		balancename: "Slot Habanero",
		providercode: "HABA",
		msg: "",
		message: "",
		gameType: "SL",
		isLoaded: false,
        action: api3RD.habaBalance,
        actiond: api3RD.habaDeposit,
        actionw: api3RD.habaWithdraw,
		port: api3RD.habaLogin,
		valSname: "Slots",
        valSvalue: "habanero_slot"
	},
	{
		balance: 0,
		money: 1000,
		balancename: "Dragoon soft",
		providercode: "DS",
		msg: "",
		message: "",
		gameType: "SL",
		isLoaded: false,
        action: api3RD.dsBalance,
        actiond: api3RD.dsDeposit,
        actionw: api3RD.dsWithdraw,
		port: api3RD.dsSLot,
		valSname: "Slots",
		valSvalue: "ds_slot",
	},
	{
		balance: 0,
		money: 1, // JILI quy đổi 1:1 VND (backend tự xử lý), số dư trả về là VND
		balancename: "JILI Slot",
		providercode: "JILI",
		msg: "",
		message: "",
		gameType: "SL",
		isLoaded: false,
		action: api3RD.jiliBalance,
		actiond: api3RD.jiliTransfer,
		actionw: api3RD.jiliTransfer,
		port: "loginEntry3rdGame",
		valSname: "Slots",
		valSvalue: "jili_slot",
	},
	{
		balance: 0,
		money: 1, // PG Soft quy đổi 1:1 VND (backend tự xử lý), số dư trả về là VND
		balancename: "PG Soft",
		providercode: "PGSOFT",
		msg: "",
		message: "",
		gameType: "SL",
		isLoaded: false,
		action: api3RD.pgsBalance,
		actiond: api3RD.pgsTransfer,
		actionw: api3RD.pgsTransfer,
		port: "loginEntry3rdGame",
		valSname: "Slots",
		valSvalue: "pgs_slot", // sảnh riêng PG Soft
	},
	{
		balance: 0,
		money: 1, // Playtech quy đổi 1:1 VND (backend tự xử lý), số dư trả về là VND
		balancename: "Playtech",
		providercode: "PT",
		msg: "",
		message: "",
		gameType: "SL",
		isLoaded: false,
		action: api3RD.ptBalance,
		actiond: api3RD.ptTransfer,
		actionw: api3RD.ptTransfer,
		port: "loginEntry3rdGame",
		valSname: "Slots",
		valSvalue: "pt_slot", // sảnh riêng Playtech
	},

	// === Others ===
	{
		balance: 0,
		money: 1,
		balancename: "V8 Poker",
		providercode: "V8",
		msg: "",
		message: "",
		gameType: "LC",
		isLoaded: false,
        action: api3RD.v8Balance,
        actiond: api3RD.v8Deposit,
        actionw: api3RD.v8Withdraw,
		port: api3RD.v8Login,
		valSname: 'Others',
		valSvalue: "v8_poker",
	},
];
